<template>
  <div id="holiday">
    <v-layout wrap class="pa-2">
      <v-flex xs12 md9>
        <div class="ml-3">
          <Formholiday
            :dialog="modal.open"
            :input="modal.input"
            @addHoliday="addHoliday"
            @updateHoliday="updateHoliday"
            @closeModal="close"
          />
          <h5 class="title" style="margin-top: 6px; margin-bottom: 23px;">Special Holiday Setup</h5>
          <div v-for="(item, k) in holidayRows" :key="item.id">
            <v-card outlined class="ma-2">
              <v-card-text class="mx-auto" max-width="344">
                <v-layout>
                  <v-flex xs10>
                    <v-list-item-content class="body-1">
                      <b>Date:</b>
                      {{item.date_from | dateFormat}} - {{item.date_to | dateFormat}}
                      <br />
                      <b>Name:</b>
                      {{item.dayname}}
                      <br />
                      <b>Message:</b>
                      {{item.message}}
                      <br />
                    </v-list-item-content>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      color="primary"
                      outline
                      @click="Object.assign(modal, { open: true, input: $options.filters.putFormat(item) })"
                      text
                      icon
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      outline
                      @click="deleteHoliday(item)"
                      x-small
                      text
                      icon
                    >
                      <v-icon small>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-flex>

      <v-flex xs3 class="text-lg-right">
        <v-btn
          outline
          @click="Object.assign(modal, { open: true, input: {  dateFrom: new Date().toISOString().substr(0, 10), dateTo: new Date().toISOString().substr(0, 10), dayname: '',  defaultMessage: ''}})"
          color="primary"
        >
          <v-icon dark>add</v-icon>ADD
        </v-btn>
        <div>
          <v-date-picker
            class="hidden-sm-and-down"
            @click:date="dateClick"
            full-width
            v-model="picker"
          ></v-date-picker>
        </div>
      </v-flex>

      <v-flex xs12>
        <hr class="my-3" />
      </v-flex>
      <v-flex xs12 md9>
        <div class="ml-3">
          <h5 class="title" style="margin-top: 6px; margin-bottom: 23px;">Default Special Holiday</h5>

          <div v-if="data&&holidayDefault">
            <v-card outlined class="ma-2">
              <v-card-text class="mx-auto" max-width="344">
                <v-layout>
                  <v-flex xs10>
                    <v-list-item-content class="body-1">
                      <b>Message:</b>
                      {{holidayDefault.message}}
                      <br />
                    </v-list-item-content>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      color="primary"
                      outline
                      @click="Object.assign(modal, { open: true, input: $options.filters.putFormat(holidayDefault) })"
                      text
                      icon
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Formholiday from './Formholiday'
import api from '@/api'
import format from 'date-fns/format'

export default {
  data() {
    return {
      picker: null,
      modal: { open: false, input: {} },
      data: []
    }
  },
  computed: {
    ...mapGetters({ selectedBot: 'selectedBot' }),
    holidayRows() {
      return this.data.filter((v, i) => !(v.id == '4' && v.dayname == '{default}'))
    },
    holidayDefault() {
      return this.data.filter((v, i) => v.id == '4' && v.dayname == '{default}')[0]
    }
  },
  mounted() {
    this.getAllholiday()
  },
  methods: {
    dateClick(e) {
      let date = format(e, 'YYYY-MM-DD')
      Object.assign(this.modal, { open: true, input: { dateFrom: date, dateTo: date } })
    },
    close() {
      this.modal.open = false
    },
    getAllholiday() {
      let vm = this
      api.getAllgeneraliholidays({ pageid: vm.selectedBot.pageid }, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.data = response.data
      })
    },
    addHoliday(item) {
      let vm = this
      vm.data.push(item)
    },
    updateHoliday(item) {
      let vm = this
      vm.data[vm.data.findIndex(v => v.id == item.id)] = item
    },
    deleteHoliday(item) {
      let vm = this
      let k = vm.data.findIndex(v => v.id == item.id)
      api.deletegeneraliholiday(item, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (response.responsecode == 200) {
          vm.data.splice(k, 1)
        }
      })
    }
  },
  filters: {
    dateFormat(val) {
      return val ? format(val, 'DD/MM/YYYY') : ''
    },
    putFormat(val) {
      return {
        dateFrom: format(val.date_from, 'YYYY-MM-DD'),
        dateTo: format(val.date_to, 'YYYY-MM-DD'),
        dayname: val.dayname,
        defaultMessage: val.message,
        pageid: val.pageid,
        id: val.id
      }
    }
  },
  components: {
    Formholiday
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/generali/holiday.vue